/* eslint-disable react/no-danger */
import { Link } from 'gatsby';
import _ from 'lodash';
import React from 'react';
import { motion } from 'framer-motion';
import { LazyLoadImage } from 'react-lazy-load-image-component';

export default function FreeZoneHomeBusinessSteps({ data, id }) {
  const {
    title,
    text,
    preApplicationTitle,
    preApplicationItems,
    postApplicationTitle,
    postApplicationItems,
    businessSteps,
    backgroundImage,
    backgroundImageMobile,
  } = data;
  return (
    <section id={id} className="bg-[#333] relative">
      <div
        className="max-w-[1326px] mx-auto relative z-10 pt-[40px] pb-[50px] lg:py-[100px]
        flex flex-col gap-y-[30px] lg:gap-y-[50px] px-6 3xl:px-0">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4, delay: 0.4 }}
          viewport={{ once: true }}
          className="flex flex-col gap-y-5 lg:gap-y-[30px] max-w-[1024px] lg:mx-auto">
          <div className="flex flex-col gap-y-5">
            <div
              dangerouslySetInnerHTML={{ __html: title }}
              className="text-clamp20to40  h2-child:text-clamp20to40 text-white
              h2-child:leading-1.25 h2-child:m-0 h2-child:md:ltr:leading-1.125 child:md:rtl:leading-1.2 
              rtl:text-right ltr:text-left lg:!text-center"
            />
            <div className="h-[2px] w-[70px] bg-[#CE445B] mx-0 lg:mx-auto" />
          </div>
          <div
            dangerouslySetInnerHTML={{ __html: text }}
            className="p-child:text-[#CCC] p-child:text-clamp12to18 p-child:font-normal
              p-child:leading-[1.6] p-child:mb-0 p-child:ltr:font-URWDINRegular 
              p-child:rtl:font-GESSTwoDWTCLight
              rtl:text-right ltr:text-left lg:!text-center w-[90%] md:w-full"
          />
        </motion.div>
        <div className="flex flex-col lg:flex-row gap-[30px] xl:gap-[12px] justify-center">
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, delay: 0.5 }}
            viewport={{ once: true }}
            className="flex flex-col gap-y-[30px] lg:gap-y-[52px] lg:max-w-[57%]">
            <div
              className="flex flex-row gap-x-5 justify-start lg:justify-center 
            lines-div relative md:w-[79.5%] xl:w-[76%] lg:mx-auto
            after:'' after:block after:lg:bg-white after:w-[1px] after:h-[30px] 
            after:absolute after:right-0 after:top-[9px]
            before:'' before:block before:lg:bg-white before:w-[1px] before:h-[30px] 
            before:absolute before:left-0 before:top-[9px] pb-[10px] md:pb-0">
              <span
                className="hidden lg:block lg:grow lg:border-t lg:border-1-white 
              relative h-[1px] top-2">
                &nbsp;
              </span>
              <span className="text-white text-clamp15to20 ltr:font-URWDINRegular 
              rtl:font-GESSTwoDWTCLight ltr:leading-1 rtl:leading-[1.3]">
                {preApplicationTitle}
              </span>
              <span
                className="hidden lg:block lg:grow lg:border-t lg:border-1-white 
              relative h-[1px] top-2">
                &nbsp;
              </span>
            </div>
            {_.isEmpty(preApplicationItems) || (
              <div className="flex flex-col lg:flex-row gap-10 xl:gap-[12px] pr-1 flex-nowrap">
                {_.map(preApplicationItems, (preApplicationItem, preApplicationItemIndex) => (
                  <Link
                    key={preApplicationItemIndex}
                    href={preApplicationItem?.content?.link?.url}
                    className="flex flex-row lg:flex-col gap-8 lg:gap-[55px] flex-1
                    items-center">
                    <div
                      className="min-w-10 lg:w-[72px] min-h-10 lg:h-[72px] flex justify-center
                      items-center bg-[#CE435B] relative rotate-45">
                      <span
                        className="text-white ltr:font-LibreBaskervilleRegular 
                        rtl:font-GESSTwoDWTCMedium  text-clamp16to30
                        font-bold -rotate-45">
                        {preApplicationItem.content.number}
                      </span>
                    </div>
                    <span
                      className="text-white ltr:font-URWDINRegular 
                      rtl:font-GESSTwoDWTCLight capitalize text-clamp13to20 leading-1.5
                    md:text-center hover:text-red">
                      {preApplicationItem.content.link.name}
                    </span>
                  </Link>
                ))}
              </div>
            )}
          </motion.div>
          <div className="bg-[#999] w-full h-[1px] lg:hidden" />
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, delay: 0.6 }}
            viewport={{ once: true }}
            className="flex flex-col gap-y-[30px] lg:gap-y-[52px] lg:w-[43%]">
            <div
              className="flex flex-row gap-x-5 justify-start lg:justify-center 
            lines-div relative md:w-[74.5%] xl:w-[68%] lg:mx-auto
            after:'' after:block after:lg:bg-white after:w-[1px] after:h-[30px] 
            after:absolute after:right-0 after:top-[9px]
            before:'' before:block before:lg:bg-white before:w-[1px] before:h-[30px] 
            before:absolute before:left-0 before:top-[9px]">
              <span
                className="hidden lg:block lg:grow lg:border-t lg:border-1-white 
              relative h-[1px] top-2">
                &nbsp;
              </span>
              <span className="text-white text-clamp15to20 ltr:font-URWDINRegular 
              rtl:font-GESSTwoDWTCLight ltr:leading-1 rtl:leading-[1.3]">
                {postApplicationTitle}
              </span>
              <span
                className="hidden lg:block lg:grow lg:border-t lg:border-1-white
              relative h-[1px] top-2">
                &nbsp;
              </span>
            </div>
            {_.isEmpty(postApplicationItems) || (
              <div className="flex flex-col lg:flex-row gap-y-[15px] lg:gap-[30px] 
              xl:gap-[10px] flex-nowrap">
                {_.map(postApplicationItems, (postApplicationItem, postApplicationItemIndex) => (
                  <div
                    key={postApplicationItemIndex}
                    className="flex flex-row lg:flex-col gap-8 lg:gap-[35px] flex-1
                    items-center ">
                    <div
                      className="min-w-10 lg:w-[92px] min-h-10 lg:h-[92px] flex justify-center
                      items-center bg-white relative rotate-45 rounded-full">
                      <span
                        className="text-[#4D4D4D] ltr:font-LibreBaskervilleRegular 
                        rtl:font-GESSTwoDWTCMedium  text-clamp16to30
                        font-bold -rotate-45">
                        {postApplicationItem.content.number}
                      </span>
                    </div>
                    <span
                      className="text-white ltr:font-URWDINRegular 
                      rtl:font-GESSTwoDWTCLight capitalize text-clamp13to20 leading-1.5
                    text-center">
                      {postApplicationItem.content.link.name}
                    </span>
                  </div>
                ))}
              </div>
            )}
          </motion.div>
        </div>

        {_.isEmpty(businessSteps) || (
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, delay: 0.7 }}
            viewport={{ once: true }}
            className="flex justify-center gap-5 pt-[10px]">
            <Link
              href={businessSteps.url}
              className="w-fit flex justify-center items-center rounded-[48px]
                    md:min-w-[250px] bg-[#CE445B] hover:bg-[#B53B50] text-white 
                    uppercase ltr:font-URWDINBold rtl:font-GESSTwoDWTCMedium ltr:tracking-[0.96px] 
                    leading-1.5 md:leading-1.25
                    min-h-[36px] md:h-[51px] text-center px-6 py-2
                    rtl:text-[12px] ltr:text-[11px] rtl:md:text-[16px] ltr:md:text-[15px] 
                    rtl:lg:text-[18px]
                    md:py-5 ">
              {businessSteps.name}
            </Link>
          </motion.div>
        )}
      </div>

      {_.isEmpty(backgroundImage) || (
        <div
          className="absolute top-0 w-full h-full lazy-load-image:!flex
        lazy-load-image:!h-full hidden md:block">
          <LazyLoadImage
            src={backgroundImage.url}
            alt={title}
            width="100%"
            effect="blur"
            wrapperClassName="bg-gradient-wrapper relative
            after:content-[''] after:block
            after:absolute after:left-0 after:w-full after:top-0 after:h-[494px] after:md:h-full
            after:bg-gradient-to-b after:from-[rgba(51,51,51,0)] after:to-[rgba(51,51,51,1)]"
            className="w-full h-[494px] md:h-full object-cover bg-blend-multiply !opacity-10"
          />
        </div>
      )}
      {_.isEmpty(backgroundImageMobile) || (
        <div
          className="absolute top-0 w-full h-full lazy-load-image:!flex
        lazy-load-image:!h-full md:hidden">
          <LazyLoadImage
            src={backgroundImageMobile.url}
            alt={title}
            width="100%"
            effect="blur"
            wrapperClassName="bg-gradient-wrapper relative
            after:content-[''] after:block
            after:absolute after:left-0 after:w-full after:top-0 after:h-[494px] after:md:h-full
            after:bg-gradient-to-b after:from-[rgba(51,51,51,0)] after:to-[rgba(51,51,51,1)]"
            className="w-full h-[494px] md:h-full object-cover bg-blend-multiply !opacity-10"
          />
        </div>
      )}
    </section>
  );
}
